import isPresent from 'volta/helpers/is-present';
import orElse from 'volta/helpers/or-else';
import unitMeasure from 'volta/helpers/unit-measure';
import BvBadge from 'volta/components/bv-badge';
import BvTag from 'volta/components/bv-tag';
import BvText from 'volta/components/bv-text';
import BvToggle from 'volta/components/bv-toggle';
import BvTooltip from 'volta/components/bv-tooltip';
import BaseCell from './base-cell';
import formatNumber from 'ember-intl/helpers/format-number';
import momentFormat from 'ember-moment/helpers/moment-format';
import utc from 'ember-moment/helpers/utc';
import and from 'ember-truth-helpers/helpers/and';
import eq from 'ember-truth-helpers/helpers/eq';
import or from 'ember-truth-helpers/helpers/or';

import type { CellBaseCellSignature } from './base-cell';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellFormatCellSignature {
  Args: CellBaseCellSignature['Args'];
}

const CellFormatCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='format-cell'
    as |baseCell|
  >
    {{#let (orElse baseCell.value.dataType 'text') as |dataType|}}
      {{#if baseCell.value.prefix}}
        <BvBadge @size='sm' @subtle={{true}} class='u-mr-1'>
          {{baseCell.value.prefix}}
        </BvBadge>
      {{/if}}
      {{#if (eq dataType 'number')}}
        <span class='u-text-numeric'>
          {{#if baseCell.value.format}}
            {{if
              (isPresent baseCell.value.value)
              (formatNumber baseCell.value.value style=baseCell.value.format)
              baseCell.value.fallback
            }}
          {{else}}
            {{if
              (isPresent baseCell.value.value)
              (formatNumber baseCell.value.value)
              baseCell.value.fallback
            }}
          {{/if}}
        </span>
      {{else if (and baseCell.value.value (eq dataType 'date'))}}
        <span class='u-text-numeric'>
          {{momentFormat (utc baseCell.value.value) (or baseCell.value.format 'L') timeZone='UTC'}}
        </span>
      {{else if (eq dataType 'boolean')}}
        <div class='u-d-flex u-justify-content-center'>
          <BvToggle @toggled={{baseCell.value.value}} @size='sm' @readOnly={{true}} />
        </div>
      {{else}}
        {{baseCell.value.value}}
      {{/if}}
      {{#if baseCell.value.unit}}
        <BvText @variant='body-sm' @color='subdued' @text={{unitMeasure baseCell.value.unit}} />
      {{/if}}
      {{#if baseCell.value.suffix}}
        <BvTag @size='sm' class='u-ml-1'>{{baseCell.value.suffix}}</BvTag>
      {{/if}}
      {{#if (or baseCell.value.tooltipText baseCell.value.tooltipContent)}}
        <BvTooltip
          @content={{baseCell.value.tooltipContent}}
          @text={{baseCell.value.tooltipText}}
        />
      {{/if}}
    {{/let}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellFormatCellSignature>;

export default CellFormatCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::FormatCell': typeof CellFormatCellComponent;
    'cell/format-cell': typeof CellFormatCellComponent;
  }
}
